<template>
  <!-- bottom部分 -->
  <div id="a0" class="a0">
    <div class="f1" @click="icon">咨询</div>

    <div class="f2" @click="left">0元会员免费学</div>
    <div id="f3" class="f3" @click="right">立即订阅</div>
  </div>
</template>

<script>
import { getCookie, setCookie } from '@/static/js/zjs'

const fsc = function(i, t) {
  if (t === void 0) return getCookie(i)
  setCookie(i, t)
}
export default {
  data() {
    return {
      dt: {
        book: {
          courseName: '',
          versionName: '',
          gradesName: ''
        }
      }
    }
  },
  async mounted() {
    this.dt = this.$parent.catalogueData
    const hash = u.path.hash.t(1)
    const id = u.qs(hash.t('?')[1])['id']

    const v = u.db.st.user.userInfo.vipLevel
    window.scrollTo(0, 0)

    await u.tm(1000, 1)
    if (hash.startsWith('/textbookDetails')) {
      if (['tingxie', 'zhishidian', 'yuedu'].includes(this.dt.category)) {
        return u.id('a0').i('s', 2)
      } else {
        u.id('a0').i('s') == 2 && u.id('a0').i('s', !1)
      }
    }
  },
  methods: {
    icon() {
      u.go('/cms/webapp/home/info/qiyukf-session.html')
    },
    left() {
      const hash = u.path.hash.t(1)
      if (hash.startsWith('/dianDuBooks')) {
        return this.ddtoVip()
      }
      if (hash.startsWith('/mjBooks')) {
        return u.go('/cms/webapp/home/vipPay/index.html#/sv')
      }
      this.toVip('svip_ymy_hymf_gn')
      // u.db.pf == 'shanxi'
      //   ? u.go('https://mp.weixin.qq.com/s/oJ6feWxSbCIvR2sZwod-Ew')
      //   : u.go('https://mp.weixin.qq.com/s/sGSgbw0PWpP2iqLngrKncg')
    },
    right() {
      this.$emit('right')
      // const hash = u.path.hash.t(1)
      // if (hash.startsWith('/dianDuBooks')) {
      //   return this.ddtoVip()
      // }
      // if (hash.startsWith('/mjBooks')) {
      //   return u.go('/cms/webapp/home/vipPay/index.html#/sv')
      // }
      // this.toVip('svip_ymy_hymf_gn')
    },
    toVip(channel) {
      if (channel === '99ZYB_ymy_1_gn') {
        return u.go('/cms/webapp/home/user/userCenter.html#/payAnswerActive?channel=99ZYB_ymy_1_gn')
      }
      u.go(`/cms/webapp/home/vipPay/index.html?channel=${channel}`)
    },
    ddtoVip() {
      this.$trackevent({ type: 'funcTracker', action: 'click', opt_label: '点读-会员免费_clcik' })
      window.location.href = '/cms/webapp/home/vipPay/index.html?channel=svip_dd_ymy_gn'
    }
  }
}
</script>

<style scoped>
div {
  bgr: no-repeat;
  d: flex;
  jc: c;
  ai: c;
}
.a0 {
  d: flex;
  ps: fixed;
  b: 0;
  w: 100%;
  h: 60;
  bgc: white;
  border-top: 0.5px solid #ececec;
}
.f1 {
  c: #666;
  f: 12;
  w: 80;
  h: 45;
  bgp: c 5;
  ai: ed;
  bgs: 22;
  bgi: url("data:image/svg+xml,%3Csvg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.92 10.664a.713.713 0 0 1 .713.713v2.85a.713.713 0 1 1-1.426 0v-2.85a.713.713 0 0 1 .713-.713zm0-2.138a2.85 2.85 0 0 0-2.85 2.851v2.85a2.85 2.85 0 0 0 5.7 0v-2.85a2.85 2.85 0 0 0-2.85-2.85zm17.103 2.138a.713.713 0 0 1 .713.713v2.85a.713.713 0 0 1-1.425 0v-2.85a.712.712 0 0 1 .712-.713zm0-2.138a2.85 2.85 0 0 0-2.85 2.851v2.85a2.85 2.85 0 1 0 5.7 0v-2.85a2.85 2.85 0 0 0-2.85-2.85z' fill='%23333'/%3E%3Cpath d='M4.345 9.46v-.121a7.126 7.126 0 1 1 14.253 0v.121h2.138v-.121a9.264 9.264 0 0 0-18.529 0v.121h2.138zm7.404 12.471a1.069 1.069 0 1 1 0-2.138c5.944 0 7.198-3.848 7.248-4.012a1.069 1.069 0 0 1 2.083.189c.014.137.002.277-.038.41-.057.206-1.682 5.551-9.293 5.551z' fill='%23333'/%3E%3Cpath d='M11.037 18.724h1.425c1.425 0 2.138.713 2.138 2.138 0 1.425-.713 2.138-2.138 2.138h-1.425c-1.426 0-2.138-.713-2.138-2.138 0-1.425.712-2.138 2.138-2.138z' fill='%23333'/%3E%3C/svg%3E");
}
.f2,
.f3 {
  f: 14;
  c: white;
  w: 140;
  h: 45;
}
.f2 {
  bgi: lg(90deg, #fec349 0.35%, #fea736 100%);
  bo: 25 0 0 25;
}
.f3 {
  bgi: lg(270deg, #ff380d 0%, #ff7236 100%);
  bo: 0 25 25 0;
}
.a0[s='1'] .f3 {
  w: 280;
  bo: 25;
}
.a0[s='1'] .f2 {
  d: no;
}
.a0[s='2'] {
  d: no;
}
.f3[s='1']::before {
  mr: 3;
  mt: 3;
  con: url("data:image/svg+xml,%3Csvg width='21' height='15' viewBox='0 0 21 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.288 5.432h1.188L3.6 9.368l2.124-3.936h1.188L4.464 9.74h1.788v.6H4.128v1.176h2.124v.6H4.128V14H3.072v-1.884H.96v-.6h2.112V10.34H.96v-.6h1.776L.288 5.432zM15.925.896c1.512 0 2.682.636 3.51 1.908.756 1.188 1.134 2.778 1.134 4.77 0 1.992-.378 3.582-1.134 4.77-.84 1.272-2.01 1.908-3.51 1.908s-2.67-.636-3.51-1.908c-.756-1.188-1.134-2.778-1.134-4.77 0-2.016.378-3.606 1.134-4.77.828-1.272 1.998-1.908 3.51-1.908zm0 1.656c-1.056 0-1.8.582-2.232 1.746-.312.768-.468 1.86-.468 3.276 0 1.404.156 2.496.468 3.276.432 1.164 1.176 1.746 2.232 1.746 1.056 0 1.8-.582 2.232-1.746.312-.828.468-1.92.468-3.276 0-1.38-.156-2.472-.468-3.276-.432-1.164-1.176-1.746-2.232-1.746z' fill='%23fff'/%3E%3C/svg%3E");
}
</style>
